import { Button } from '@writefull/core'
import { clsx } from '@writefull/utils'

import useSessionStore from '@infrastructure/stores/session/session-store'

import DarkModeToggle from './DarkModeToggle'
import UserMenu from './UserMenu'

interface HeaderProps {
  hasScrolled: boolean
  onSignInClick: () => void
}

export default function Header({ hasScrolled, onSignInClick }: HeaderProps) {
  const isInitialized = useSessionStore.use.isInitialized()
  const user = useSessionStore.use.user()

  return (
    <>
      <header
        className={clsx(
          'sticky top-0 w-full z-2 min-h-12',
          'flex justify-end p-2 items-center md:p-4 gap-3 theme theme-transition',
          hasScrolled
            ? 'shadow-md md:shadow-none md:border-b md:border-gray-200 dark:md:border-slate-600'
            : '',
        )}
      >
        <DarkModeToggle />
        {isInitialized && (
          <>
            {user ? (
              <UserMenu />
            ) : (
              <Button type='button' variant='primary' size='large' onClick={onSignInClick}>
                Log in
              </Button>
            )}
          </>
        )}
      </header>
    </>
  )
}
